<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile @click="printAllReport('printReport')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.productIds"
                :items="selectedProductList"
                label="Product"
                @click="showProducts()"
                item-text="code"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.customerIds"
                :items="selectedCustomerList"
                label="Customer"
                @click="showCustomers()"
                item-text="code"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.categoryIds"
                :items="categoryList"
                label="Category"
                item-text="name"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="payTypes"
                label="PayType"
                item-text="label"
                item-value="value"
                v-model="queryParams.payType"
              ></v-select>
            </v-flex>
            <v-flex
              sm3
              v-if="
                user.role.roleName == 'ADMIN' ||
                user.role.roleName == 'BRANCH_ADMIN'
              "
            >
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Grand Total Amount:</span>
              <v-chip>
                <span>{{ grandTotalAmount | decFormat(6) }}</span>
              </v-chip>
              <span>Grand Total Amount(%):</span>
              <v-chip>
                <span>{{ grandTotalPercentAmount | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="saleReportByProductCodeList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.date }}</td>
              <td>{{ props.item.productCode }}</td>
              <td>{{ props.item.productName }}</td>
              <td>{{ props.item.customerCode }}</td>
              <td>{{ props.item.customerName }}</td>
              <td>{{ props.item.qty | decFormat(6) }}</td>
              <td style="text-align: right">
                {{ props.item.price | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.amount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.discountPrice | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.discountAmount | decFormat(6) }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <print all> -->
    <div
      id="printReport"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Product Sale Report by Customer
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 1px">
          Category : {{ filterCategory }}
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th
                style="border: 1px solid black; text-align: center; width: 80px"
              >
                Date
              </th>
              <th style="border: 1px solid black; text-align: center">
                Product Code
              </th>
              <th style="border: 1px solid black; text-align: center">
                Product Name
              </th>
              <!-- <th style="border:1px solid black;text-align:center">Customer Code</th> -->
              <th style="border: 1px solid black; text-align: center">
                Customer Name
              </th>
              <th style="border: 1px solid black; text-align: center">Price</th>
              <th style="border: 1px solid black; text-align: center">Qty</th>
              <th style="border: 1px solid black; text-align: center">
                Amount
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(saleReport, index) in allSaleReportByProductCodeList"
            :key="index"
          >
            <!-- <tr style="border:1px solid black;text-align:left">
              <td style="border:1px solid black;font-weight:bold" colspan="7">{{ saleReport.date }}</td>
            </tr> -->
            <tr
              v-for="(item, i) in saleReport.saleReportByProductCodeDTOList"
              :key="i"
            >
              <td
                style="border: 1px solid black; text-align: left; width: 80px"
              >
                {{ saleReport.date }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productName }}
              </td>
              <!-- <td style="border:1px solid black;text-align:left">{{ item.customerCode }}</td> -->
              <td style="border: 1px solid black; text-align: left">
                {{ item.customerName }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.price | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.qty | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.amount | decFormat(6) }}
              </td>
            </tr>
            <tr style="border: 1px solid black; text-align: right">
              <td
                style="border: 1px solid black; font-weight: bold"
                colspan="5"
              >
                Sub Total
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ saleReport.totalQty | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ saleReport.subTotal | decFormat(6) }}
              </td>
            </tr>
          </tbody>
          <tr>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
              colspan="5"
            >
              Grand Total
            </td>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
            >
              {{ allTotalQty | decFormat(6) }}
            </td>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
            >
              {{ grandTotalPercentAmount | decFormat(6) }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="productQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="productQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="productQueryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="productQueryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="productQueryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchProduct">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                v-model="selectedProductList"
                :headers="productHeaders"
                :items="productList"
                select-all
                class="elevation-1"
                :loading="showListLoading"
                :total-items="producttotalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="productpagination"
                :must-sort="true"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th>
                      <v-checkbox
                        primary
                        hide-details
                        @click.native="toggleAll"
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                      ></v-checkbox>
                    </th>
                    <th v-for="header in props.headers" :key="header.text">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox
                      primary
                      hide-details
                      :input-value="props.selected"
                      :value="props.item"
                      :indeterminate="props.indeterminate"
                      v-model="selectedProductList"
                      multiple
                    ></v-checkbox>
                  </td>
                  <td>
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">
                    {{ props.item.productGroup.name }}
                  </td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
              <div class="text-xs-right">
                <v-btn color="primary" @click="setProduct">Ok</v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End dialog -->

    <!-- Customer dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="code"
                label="Customer Code"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="email"
                label="Customer Email"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.email"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchCustomer">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              v-model="selectedCustomerList"
              :headers="customerHeader"
              :items="activeCustomerList"
              select-all
              class="elevation-1"
              :loading="showListLoading"
              :total-items="customertotalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="customerpagination"
              :must-sort="true"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th>
                    <v-checkbox
                      primary
                      hide-details
                      @click.native="toggleAll"
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                    ></v-checkbox>
                  </th>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    :input-value="props.selected"
                    :value="props.item"
                    :indeterminate="props.indeterminate"
                    v-model="selectedCustomerList"
                    multiple
                  ></v-checkbox>
                </td>
                <td>
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ props.item.phoneNo }}</td>
                <td>{{ props.item.creditLevel.name }}</td>
              </template>
            </v-data-table>
            <div class="text-xs-right">
              <v-btn color="primary" @click="setCustomer">Ok</v-btn>
            </div>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End dialog -->
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { customerService } from "../../services/customer-service";
import { saleReportService } from "../../services/sale-report-service";
import { productService } from "../../services/product-service";
import { categoryService } from "../../services/category-service";
import { shopService } from "../../services/shop-service";

export default {
  name: "SaleReportByCode",
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Sale Reports",
        disabled: true,
      },
      {
        text: "Product Sale Report By Customer",
        disabled: true,
      },
    ],
    showCustomerListDialog: false,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      productIds: [],
      customerIds: [],
      categoryIds: [],
      shopId: "",
      payType: "",
      updateUserId: "",
    },
    selectedCustomerList: [],
    activeCustomerList: [],
    customertotalRows: 0,
    productQueryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
    },
    customerQueryParams: {
      name: "",
      code: "",
      email: "",
    },
    productpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "null",
      totalItems: 0,
    },
    headers: [
      { text: "Date", align: "left", sortable: false },
      { text: "Product Code", align: "left", sortable: false },
      { text: "Product Name", align: "left", sortable: false },
      { text: "Customer Code", align: "left", sortable: false },
      { text: "Customer Name", align: "left", sortable: false },
      { text: "Qty", align: "left", sortable: false },
      { text: "Price", align: "left", sortable: false },
      { text: "Total", align: "left", sortable: false },
      { text: "Price(%)", align: "left", sortable: false },
      { text: "Total(%)", align: "left", sortable: false },
    ],
    customerHeader: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
    ],
    customerpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0,
    },
    productHeaders: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    rowsPerPageItems: [25, 50, 100],
    producttotalRows: 0,
    totalRows: 0,
    grandTotalAmount: 0,
    grandTotalPercentAmount: 0,
    allTotalQty: 0,
    selectedProductList: [],
    productList: [],
    shopList: [],
    categoryList: [],
    saleReportByProductCodeList: [],
    allSaleReportByProductCodeList: [],
    showProductListDialog: false,
    showListLoading: false,
    buttonLoading: false,
    clonequeryParams: new Object(),
    filterCategory: "ALL",
    payTypes: [
      { label: "----All----", value: "" },
      { label: "CASH", value: "CASH" },
      { label: "CREDIT", value: "CREDIT" },
    ],
  }),
  watch: {
    pagination: {
      handler() {
        this.getSaleReportByCodeList();
      },
      deep: true,
    },
    productpagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
    customerpagination: {
      handler() {
        this.getActiveCustomer();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = this.$route.query.updateUserId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.decimalFormat = commonService.formatdecimal();
    if (
      this.user.role.roleName == "GENERAL_MANAGER" ||
      this.user.role.roleName == "SALE_MANAGER" ||
      this.user.role.roleName == "BRANCH_ADMIN"
    ) {
      this.queryParams.shopId = this.user.shopId;
      if (this.user.role.roleName == "SALE_MANAGER") {
        this.queryParams.updateUserId = this.user.id;
      }
    }
    this.getShopList();
    this.getCategoriesByStatus();
    this.onSearch();
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "sale-report-by-code",
        query: this.queryParams,
      });
      this.getSaleReportByCodeList();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
      if (this.queryParams.categoryIds.length > 0) {
        this.filterCategory = "";
        for (var i = 0; i < this.queryParams.categoryIds.length; i++) {
          let category = commonService.search(
            "id",
            this.queryParams.categoryIds[i],
            this.categoryList
          );
          this.filterCategory += category.name + ", ";
        }
      } else {
        this.filterCategory = "ALL";
      }
    },
    getSaleReportByCodeList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      saleReportService
        .getSaleReportByProductCode(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.saleReportByProductCodeList =
              res.data.saleReportByProductCodeDTOList;
            this.grandTotalAmount = res.data.grandTotal;
            this.grandTotalPercentAmount = res.data.grandTotalPercent;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.error(err);
        });
    },
    showProducts() {
      // Clean query params
      this.productQueryParams.productCode = "";
      this.productQueryParams.productName = "";
      this.productQueryParams.brandName = "";
      this.productQueryParams.categoryName = "";
      this.productQueryParams.productGroupName = "";
      this.selectedProductList = [];
      this.queryParams.productIds = [];
      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },
    showCustomers() {
      // Clean query params
      this.customerQueryParams.code = "";
      this.customerQueryParams.name = "";
      this.customerQueryParams.email = "";
      this.selectedCustomerList = [];
      this.queryParams.customerIds = [];

      this.getActiveCustomer().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );
    },
    setCustomer() {
      if (this.selectedCustomerList.length) {
        this.queryParams.customerIds = [];
        this.selectedCustomerList.forEach((element) => {
          if (!this.queryParams.customerIds.includes(element.id))
            this.queryParams.customerIds.push(element.id);
        });
      }
      this.showCustomerListDialog = !this.showCustomerListDialog;
    },
    onSearchCustomer() {
      this.customerQueryParams.page = this.customerpagination.page;
      this.customerQueryParams.size = this.customerpagination.rowsPerPage;
      this.getActiveCustomer();
    },
    getActiveCustomer() {
      this.showListLoading = true;
      let order = this.customerpagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerQueryParams,
          this.customerpagination.page,
          this.customerpagination.rowsPerPage,
          this.customerpagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.activeCustomerList = res.data.customerList;
            this.customertotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.productpagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.productQueryParams,
          this.productpagination.page,
          this.productpagination.rowsPerPage,
          this.productpagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.producttotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    setProduct() {
      if (this.selectedProductList.length) {
        this.queryParams.productIds = [];
        this.selectedProductList.forEach((element) => {
          if (!this.queryParams.productIds.includes(element.id))
            this.queryParams.productIds.push(element.id);
        });
      }
      this.showProductListDialog = !this.showProductListDialog;
    },

    toggleAll() {
      if (this.selectedProductList.length) {
        this.selectedProductList = [];
      } else {
        this.selectedProductList = this.productList.slice();
      }
    },
    onSearchProduct() {
      this.productQueryParams.page = this.productpagination.page;
      this.productQueryParams.size = this.productpagination.rowsPerPage;
      this.getProductList();
    },
    getCategoriesByStatus() {
      return categoryService
        .getCategoriesByStatus("ACTIVE")
        .then((res) => {
          this.categoryList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    printAllReport(divName) {
      this.buttonLoading = true;
      saleReportService
        .getPrintAllSaleReportByProductCode(this.clonequeryParams)
        .then((res) => {
          this.allSaleReportByProductCodeList =
            res.data.SaleReportByProductCodePageDTOList;
          this.grandTotalPercentAmount = res.data.grandTotalPercentAmount;
          this.allTotalQty = res.data.allTotalQty;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
  },
};
</script>